import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { Outlet, useLocation } from "react-router-dom";
// import { screenChange } from "../../store/screenSlice";
import FindMemberMenu from "../../components/FindMember/FindMemberMenu";

import CreateOrder from "../../components/Order/CreateOrder";
import ViewOrder from "../../components/Order/ViewOrder";
import OrderList from "../../components/Order/OrderList";
import { screenConfig } from "../../config/screenConfig";
import EditOrder from "../../components/Order/EditOrder";
// import "./Order.css";

const Order: React.FC = () => {
  const dispatch = useDispatch();

  const currentMenu = useSelector(
    (state: RootState) => state.screen.currentMenu
  );

  console.log("currentMenu:", currentMenu);

  const renderMenuPage = () => {
    switch (currentMenu) {
      // case screenConfig.createOrder:
      //   return <CreateOrder />;
      //   break;
      case screenConfig.viewOrder:
        return <ViewOrder />;
        break;
      case screenConfig.editOrder:
        return <EditOrder />;
        break;
      default:
        return <OrderList />;
        break;
    }
  };

  // dispatch(screenChange("Events"));

  return <div className="dashboard-wrapper">{renderMenuPage()}</div>;
};

export default Order;
